import { AxnAttributeType } from "@idw-types/data/reference-data/axn";
import {
    VerificationTransactionDetailsTrustScoreInput,
    FormattedVerificationTransactionDetailsTrustScoreInput
} from "@idw-types/data/verification-transaction-details";
import { safelyParseIntFromString } from "@utils/string-util";

export const formatVerificationTransactionDetailsTrustScoreInputs = (
    trustScoreInputs: Array<VerificationTransactionDetailsTrustScoreInput>,
    attributeTypes: Array<AxnAttributeType>
): Array<FormattedVerificationTransactionDetailsTrustScoreInput> => {
    return trustScoreInputs.map(input => formatVerificationTransactionDetailsTrustScoreInput(input, attributeTypes));
};

export const formatVerificationTransactionDetailsTrustScoreInput = (
    trustScoreInput: VerificationTransactionDetailsTrustScoreInput,
    attributeTypes: Array<AxnAttributeType>
): FormattedVerificationTransactionDetailsTrustScoreInput => {
    const attributeType = attributeTypes.find(a => a.id === trustScoreInput.attributeTypeID);

    let dateCreated = null;
    if (trustScoreInput.dateCreated) {
        dateCreated = new Date(parseInt(trustScoreInput.dateCreated));
    }

    return {
        attributeType: attributeType,
        dateCreated: dateCreated,
        id: trustScoreInput.id,
        normalizedScore: safelyParseIntFromString(trustScoreInput.normalizedScore),
        orderNumber: trustScoreInput.orderNumber,
        rawScore: safelyParseIntFromString(trustScoreInput.rawScore),
        scoreRangeMax: safelyParseIntFromString(trustScoreInput.scoreRangeMax),
        scoreRangeMin: safelyParseIntFromString(trustScoreInput.scoreRangeMin),
        scoreWeight: safelyParseIntFromString(trustScoreInput.scoreWeight),
        trustScoreBreakdownID: trustScoreInput.trustScoreBreakdownID,
        weightedScore: safelyParseIntFromString(trustScoreInput.weightedScore),
        weightedScoreTotalAfter: safelyParseIntFromString(trustScoreInput.weightedScoreTotalAfter),
        weightedScoreTotalBefore: safelyParseIntFromString(trustScoreInput.weightedScoreTotalBefore)
    };
};